<template>
	<editor
		:show.sync="editorVisible"
		:data-model-name="editorDataModel"
		:record-id="recordId"
		:fields="editorFields"
		@change="doChange"
		v-if="editorVisible"
	></editor>
</template>

<script>
export default {
	data() {
		return {
			editorDataModel: "Order",
			editorFields: [
				{
					name: "name",
					rules: ["required"],
					width: "100%"
				},
				{
					name: "saler",
					col:6
				},
				{
					name: "express_type",
					col:6
				},
				{
					name: "primary_img"
				},
				{
					name: "desc"
				},
			]
		};
	},
	computed: {
		editorVisible: {
			get: function() {
				return this.show;
			},
			set: function(val) {
				this.$emit("update:show", val);
			}
		}
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		recordId: {
			type: String,
			default: ""
		}
	},
	methods: {
		doChange(val) {
			this.$emit("change", val);
		}
	}
};
</script>